export default __webpack_public_path__ + "static/media/lunamiel.3e71e108.svg";